import { Component, OnInit, Input } from '@angular/core';
import { FADE_IN } from '../../util/animations/animation';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css'],
  animations: [FADE_IN]
})
export class UnauthorizedComponent implements OnInit {
  @Input() message = 'No new message to be display'
  constructor() { }

  ngOnInit(): void {
  }

}
